export default "__VITE_ASSET__12755b6d__"